import { string } from 'fp-ts';
export const logChildLabels = Symbol('labels');
/**
 * Merges a child context into a parent context
 *   - Merges labels into a single label
 *   - Overrides properties on the parent with properties from the child
 */
export const mergeChildContext = (parentContext) => (arg1, arg2) => {
    const parentLabels = parentContext[logChildLabels] ?? [];
    const [childLabel, childContext] = typeof arg1 === 'string' ? [arg1, arg2 ?? {}] : [undefined, arg1];
    return {
        ...parentContext,
        ...childContext,
        [logChildLabels]: [...parentLabels, childLabel].filter(string.isString),
    };
};
//# sourceMappingURL=LogContext.js.map